import SimpleLayout from "../../core/components/layout/SimpleLayout";
import {
    Button,
    Card,
    Checkbox,
    Col,
    Form,
    Input,
    InputNumber,
    Row,
    AutoComplete,
    Select, Tabs, Tooltip, Modal, Typography, notification, Collapse, Result, Grid,
} from "antd";
import { t } from "i18next";
import CountryPhoneInput, { ConfigProvider } from "antd-country-phone-input";
import { useEffect, useRef, useState } from "react";
import { isMobile } from "react-device-detect";
import Helper from "../../core/Helper";
import PatientSelect from "../patient/PatientSelect";
import en from "world_countries_lists/data/countries/en/world.json";
import { useModal } from "../../core/context/ModalContext";
import AppointmentFilter from "./calendar/AppointmentFilter";
import AppointmentMenu from "./calendar/AppointmentMenu";
import Calendar from "./calendar/Calendar";
import { CalendarProvider } from "./calendar/CalendarContext";
import { useHistory, useLocation, useParams } from "react-router-dom";
import moment from "moment/moment";
import ApiService from "../../core/service/ApiService";
import { v4 } from "uuid";
import AppointmentDetailEdit from "./AppointmentDetailEdit";
import { DataGridProvider } from "../../core/components/data-grid/DataGridContext";
import AddonBefore from "../../core/components/AddonBefore";
import MultiplePaymentApp, { Currency } from "../Payment/MultiplePaymentApp";
import { PERMISSIONS, useUser } from "../../core/context/UserContext";
import { CheckOutlined, WarningOutlined } from "@ant-design/icons";
import DebounceInput from "../../core/components/DebounceInput";
import NotificationService from "../../core/service/NotificationService";
import { AppointmentPatientDataGrid } from "./appointment-patient/AppointmentPatientDataGrid";
import AppConfig from "../../core/service/AppConfig";
import AppointmentFiles from "./files/AppointmentFiles";
import PatientFiles from "../patient/PatientFiles";
import PatientKvkk from "../patient/PatientKvkk";
import TabPane from "antd/lib/tabs/TabPane";
import AppointmentReminder from "../patient/patient-reminder/AppointmentReminder"
import PatientBillingAddress from "../patient/patient-billing-address/PatientBillingAddress"

const getDate = (dateStr) => {
    if (!dateStr || dateStr.length < 12)
        return moment()

    const dateObj = {
        year: parseInt(dateStr.substring(0, 4)),
        month: parseInt(dateStr.substring(4, 6)) - 1,
        day: parseInt(dateStr.substring(6, 8)),
        hour: parseInt(dateStr.substring(8, 10)),
        minute: parseInt(dateStr.substring(10, 12)),
    };

    const date = moment();
    date.set({
        year: dateObj.year,
        month: dateObj.month,
        date: dateObj.day,
        hour: dateObj.hour,
        minute: dateObj.minute
    })

    return date;
}

export default function PatientApp() {
    const location = useLocation();
    const params = useParams();
    const history = useHistory()
    const screens = Grid.useBreakpoint()

    const unitId = Helper.UrlParams.getUrlParam(location.search, 'unitId');
    const unitName = Helper.UrlParams.getUrlParam(location.search, 'unitName');
    const firmId = Helper.UrlParams.getUrlParam(location.search, 'firmId');
    const firmName = Helper.UrlParams.getUrlParam(location.search, 'firmName');
    const startDate = getDate(Helper.UrlParams.getUrlParam(location.search, 'startDate'));
    const endDate = getDate(Helper.UrlParams.getUrlParam(location.search, 'endDate'));

    const { hasPermission } = useUser();
    const selectedAppointmentRef = useRef(null)
    const [filter, setFilter] = useState({
        patientId: params.patientId,
        oldPatientId: params.patientId,
        stateGroupIdList: [],
        hideZeroBalance: false
    })

    const [tableUpdate, setTableUpdate] = useState(null)
    const [patientData, setPatientData] = useState({})
    const [selectedAppointments, setSelectedAppointments] = useState([])
    const [newAppointment, setNewAppointment] = useState(null)
    const [validate, setValidate] = useState({})
    const [checked, setChecked] = useState(false)
    const openPayment = useRef(false)
    const onEnterRef = useRef(false)
    const patientFormRef = useRef()
    const { openModal, closeModal } = useModal()

    const addAppointment = (params) => {
        setSelectedAppointments([])
        selectedAppointmentRef.current = null
        setNewAppointment({ ...params, newRecord: true })
    }
    const openCalendar = () => {
        const modalComponent = (
            <>
                <CalendarProvider>
                    <div
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'space-between',
                            marginBottom: 12,
                            gap: 8
                        }}
                    >
                        <AppointmentFilter />
                        <AppointmentMenu />
                    </div>
                    <Calendar
                        onSelect={(params) => {
                            addAppointment({
                                ...params,
                                startDate: getDate(params.startDate),
                                endDate: getDate(params.endDate),
                            })
                            closeModal()
                        }}
                    />
                </CalendarProvider>
            </>
        )
        openModal('', modalComponent, () => { })
    }

    const getPatient = async (patientId) => {
        if (patientId) {
            const res = await ApiService.Patient.GetPatient(patientId)
            if (res.success) {
                if (res.data?.note && window.AppSettings?.his?.patientNotePopup) {
                    openModal(
                        t('Patient Note'),
                        (
                            <Result
                                status="warning"
                                title={res.data.note}
                            />
                        ),
                        () => { }
                    )
                }

                const data = {
                    ...res.data,
                    phone1: {
                        code: res.data.phoneCode1 || 90,
                        phone: Helper.Phone.phoneFormat(res.data.phone1)
                    },
                    phone2: {
                        code: res.data.phoneCode2 || 90,
                        phone: Helper.Phone.phoneFormat(res.data.phone2)
                    },
                }

                document.title = `${data.name} ${data.lastname} - ${AppConfig.getHisTitle()}`
                return data
            }
        }
    }

    const init = async (patientId) => {
        const data = await getPatient(patientId)
        patientFormRef.current.setFieldsValue({
            ...data
        })

        setPatientData({
            ...data,
            originalCustomId: data.customId,
        })

        createValidation(data.id && data.validate)
    }

    const updateFilter = async (_filter) => {
        if (newAppointment) {
            setFilter(_filter)
        } else {
            const consent = await checkKvkkConsent(_filter.patientId);
            if (!consent) {
                notification.warning({
                    message: t('KVKK onayı olmadan işlem yapılamaz.')
                });
                return;
            }

            await saveAppointment(_filter.patientId, selectedAppointmentRef.current)
            window.location.href = `/app/patients/${_filter.patientId}/appointments/${selectedAppointmentRef.current?.id}`
        }
    }

    const savePatient = async (showSuccess) => {
        await patientFormRef.current.validateFields();

        const formData = patientFormRef.current.getFieldsValue()
        const input = {
            ...formData,
            phoneCode1: formData.phone1?.code,
            phone1: Helper.Phone.clearPhoneFormat(formData.phone1?.phone),
            phoneCode2: formData.phone2?.code,
            phone2: Helper.Phone.clearPhoneFormat(formData.phone2?.phone),
        }

        if (filter.patientId) {
            const res = await ApiService.Patient.EditPatient(filter.patientId, input, showSuccess)

            if (res.success) {
                return filter.patientId
            }
        }
        else {
            const res = await ApiService.Patient.CreatePatient(input, showSuccess)

            if (res.success) {
                await updateFilter({
                    ...filter,
                    patientId: res.data,
                    stateGroupIdList: [1]
                });

                const consent = await checkKvkkConsent(res.data);
                if (!consent) {
                    notification.warning({
                        message: t('KVKK onayı olmadan işlem yapılamaz.')
                    });
                    return null;
                }

                return res.data
            }
        }
    }

    const checkKvkkConsent = async (patientId) => {
        return new Promise(async (resolve) => {
            if (!patientId) {
                resolve(true);
                return;
            }

            const kvkkRes = await ApiService.Patient.IsKvkkConfirmed(patientId);
            if (kvkkRes.success && !kvkkRes.data) {
                openModal(
                    t('KVKK'),
                    <PatientKvkk
                        patientId={patientId}
                        onApproved={async () => {
                            resolve(true);
                            closeModal();
                        }}
                        onCancel={() => {
                            resolve(false);
                        }}
                    />,
                    () => {
                        resolve(false);
                    }
                );
            } else {
                resolve(true);
            }
        });
    }

    const saveAppointment = async (_patientId, appointment) => {
        const _input = {
            firmId: appointment.firm.id,
            patientId: _patientId,
            unitId: appointment.unit.id,
            startDate: appointment.startDate,
            endDate: appointment.endDate,
            note: appointment.note,
            anamnez: appointment.anamnez,
            doctorId: appointment.doctor.id,
            institutionId: appointment.institution.id,
            provisionNo: appointment.provisionNo,
            privateNote: appointment.privateNote,
            currency: appointment.currency ?? Currency.TRY,
            operationList: appointment.appointmentOperations.map(x => ({
                operationId: x.operationId,
                processMinute: x.processMinute,
                accessionNumber: x.accessionNumber,
                subItems: x.subItems.map(x => ({
                    ...x,
                    tagList: []
                })),
                price: x.price
            })),
            otherOperations: appointment.appointmentOtherOperations.map(x => ({
                name: x.name,
                price: x.price
            })),
            appointmentFiles: [],
            checkIn: appointment.checkIn,
            stateId: appointment?.state?.id,
            stateDescForm: appointment.stateDesc,
            appointmentTypeId: appointment?.appointmentTypeId,
            sendEnabiz: appointment.sendEnabiz !== false
        }

        if (appointment.newRecord) {
            const res = await ApiService.Appointment.CreateAppointment(_input)
            if (res.success) {
                setSelectedAppointments([])
                selectedAppointmentRef.current = null
                setNewAppointment(null)
                history.push(`/app/patients/${_patientId}/appointments/${res.data}`)
            }
        }
        else {
            await ApiService.Appointment.EditAppointment(appointment.id, _input)
        }

        setTableUpdate(v4())
    }

    const openPaymentModal = (patient) => {
        const currencyList = Array.from(new Set(selectedAppointments.map(x => x.currency)))
        if (currencyList?.length > 1) {
            NotificationService.error('Aynı anda farklı para birimlerine sahip randevuya ödeme alınamaz!', 'Lütfen aynı para birimine sahip randevuları seçin.')
            return
        }

        const component = (
            <MultiplePaymentApp
                idList={selectedAppointments.filter(x => typeof x.appointmentId !== 'object').map(x => x.appointmentId)}
                patientId={filter.patientId}
                onSave={() => {
                    setTableUpdate(v4())
                }}
                onDelete={() => {
                    setTableUpdate(v4())
                }}
            />
        )
        openModal(t('Payments'), component, () => { })
    }

    const createValidation = (isValidate) => {
        if (isValidate) {
            setValidate({
                ...validate,
                birthdate: { required: true, message: `` },
                gender: { required: true, message: `` },
                customId: { required: true, message: `${t('Identity')} ${t('is required')}` },
                otherPatientId: { required: false, message: `${t('Other Patient')} Id ${t('is required')}` },
                phone1: {
                    required: true,
                    validator: async (_, value) => {
                        if (!value.phone)
                            return Promise.reject('Lütfen telefon numarasını giriniz!');

                        if ((validate.phone1 || value.phone) && value.phone.length !== 15)
                            return Promise.reject('10 hane olarak giriniz!');

                        return true
                    }
                },
            })
        }
        else {
            setValidate((prev) => {
                return {
                    birthdate: { required: false, message: `${t('Birthdate')} ${t('is required')}` },
                    gender: { required: false, message: `${t('Sex')} ${t('is required')}` },
                    customId: { required: false, message: `${t('Identity')} ${t('is required')}` },
                    otherPatientId: { required: false, message: `${t('Other Patient')} Id ${t('is required')}` },
                    phone1: { required: false, message: `${t('Phone')} 1 ${t('is required')}` }
                }
            })
        }
    }

    const openPatientResults = async () => {
        const res = await ApiService.Patient.GetToken(filter.patientId);
        if (res.success) {
            const url = `${window.AppSettings.server.result}?access_token=${res.data}`
            window.open(url, '_blank')
        }
    }

    const onChecked = async () => {
        if (checked) {
            createValidation(true)
            await patientFormRef.current.validateFields()
        }
        else {
            createValidation((patientData.id && patientData.validate))
            await patientFormRef.current.validateFields()
        }
    }

    function validateTCKN(tckn) {
        if (!tckn)
            return

        if (!/^\d{11}$/.test(tckn)) return false;

        const digits = tckn.split('').map(Number);

        const oddSum = digits[0] + digits[2] + digits[4] + digits[6] + digits[8];
        const evenSum = digits[1] + digits[3] + digits[5] + digits[7];
        const checkDigit10 = ((7 * oddSum) - evenSum) % 10;

        if (checkDigit10 !== digits[9]) return false;

        const checkDigit11 = digits.slice(0, 10).reduce((a, b) => a + b, 0) % 10;

        if (checkDigit11 !== digits[10]) return false;

        return true;
    }

    const selectPatient = async (customId, noPatient, extraConfirm) => {
        const res = await ApiService.Patient.GetPatientByCustomId(customId, !noPatient);
        if (res.success && !res?.data && noPatient) {
            Modal.error({
                content: (
                    <>
                        <Typography.Title level={4}>
                            {t('No patient found with this identity number.')}
                        </Typography.Title>
                    </>
                )
            })
            return
        }

        if (res.success && res?.data) {
            const patient = res.data;

            if (!extraConfirm) {
                const oldId = filter.patientId;
                await updateFilter({
                    ...filter,
                    patientId: patient.id,
                    oldPatientId: oldId
                })
            }
            else {
                Modal.confirm({
                    content: (
                        <>
                            <Typography.Title level={4}>
                                {t('Bu kimlik numarası ile kayıtlı bir hasta bulunmaktadır. Hasta bilgilerini yüklemek ister misiniz?')}
                            </Typography.Title>
                            <Typography.Text>
                                {patient?.name} {patient?.lastname} <br />
                                {patient?.customId} <br />
                                {patient?.phone1} <br />
                            </Typography.Text>
                        </>
                    ),
                    onOk: async () => {
                        const oldId = filter.patientId;
                        await updateFilter({
                            ...filter,
                            patientId: patient.id,
                            oldPatientId: oldId
                        })
                    },
                    onCancel: () => { },
                })
            }
        }
    }

    const renderKvkkStatus = () => {
        if (patientData?.kvkkStatus === 'WAITING') {
            return (
                <Typography.Text style={{ color: 'orange' }}>
                    {t('KVKK Waiting')}
                </Typography.Text>
            )
        }
        else if (patientData?.kvkkStatus === 'APPROVED') {
            return (
                <Typography.Text style={{ color: 'green' }}>
                    {t('KVKK Approved')}
                </Typography.Text>
            )
        }
        else if (patientData?.kvkkStatus === 'SKIP_KVKK') {
            return (
                <Typography.Text style={{ color: 'red' }}>
                    {t('KVKK Approval Skipped')}
                </Typography.Text>
            )
        }
    }

    useEffect(() => {
        if (filter.patientId) {
            init(filter.patientId)
        }
    }, [filter.patientId]);

    useEffect(() => {
        if (window.location.href.includes('payments') && selectedAppointments?.length > 0 && !openPayment.current) {
            openPayment.current = true
            openPaymentModal(patientData)
        }
    }, [selectedAppointments]);

    useEffect(() => {
        onChecked()
    }, [checked, patientData]);

    useEffect(() => {
        if (unitId) {
            addAppointment({
                unitId,
                unitName,
                firmId,
                firmName,
                startDate,
                endDate
            })
        }
    }, []);

    useEffect(() => {
        if (tableUpdate) {
            init(filter.patientId)
        }
    }, [tableUpdate]);
    return (
        <SimpleLayout fullWidth={true}>
            <Card>
                <Row gutter={[16, 16]}>
                    <Col xs={24} xl={12}>
                        <Tabs
                            onTabClick={(key, e) => {
                                if (key === "2" && !patientData?.validate) {
                                    e.preventDefault();
                                    alert("Lütfen önce validasyonu tamamlayın!");
                                }
                            }}
                        >
                            <TabPane tab={t("Patient Info")} key="1">
                                <Card
                                    title={(
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: !screens.md ? 'column' : 'row',
                                            alignItems: !screens.md ? 'stretch' : 'center',
                                            justifyContent: 'space-between',
                                            gap: 8,
                                            backgroundColor: '#f5f5f5',
                                            marginBottom: 8
                                        }}>
                                            {t('Patient Card')}
                                            <PatientSelect
                                                onSelect={async (patId, patient) => {
                                                    const oldId = filter.patientId;
                                                    if (oldId && oldId !== patId) {
                                                        Modal.confirm({
                                                            title: t('Do you want to save the current patient?'),
                                                            content: (
                                                                <div style={{ width: 600 }}>
                                                                    <Typography.Text>
                                                                        {t('The selected patient information will be saved.')}
                                                                    </Typography.Text>
                                                                </div>
                                                            ),
                                                            onOk: async () => {
                                                                await updateFilter({
                                                                    ...filter,
                                                                    patientId: patId,
                                                                    oldPatientId: oldId
                                                                })
                                                            }
                                                        })
                                                    }
                                                    else {
                                                        await selectPatient(patient?.customId, true, false)
                                                    }

                                                }}
                                            />
                                            {
                                                hasPermission(PERMISSIONS.APPOINTMENT_CREATE_EDIT) && (
                                                    <Button
                                                        type={'primary'}
                                                        style={{ width: !screens.md ? '100%' : 95 }}
                                                        size={'small'}
                                                        onClick={async () => {
                                                            const kvkkApproved = await checkKvkkConsent(filter.patientId);
                                                            if (!kvkkApproved) {
                                                                NotificationService.error(t('KVKK approval is required to save the appointment.'), t('Please approve KVKK consent.'));
                                                                return;
                                                            }

                                                            await savePatient()
                                                        }}
                                                    >
                                                        {t('Save Patient')}
                                                    </Button>
                                                )
                                            }
                                        </div>
                                    )}
                                    style={{ backgroundColor: '#f5f5f5' }}
                                >
                                    <Typography.Text>
                                        {renderKvkkStatus()}
                                    </Typography.Text>
                                    <ConfigProvider locale={en}>
                                        <Form
                                            size={'small'}
                                            layout={'vertical'}
                                            initialValues={{
                                                phone1: {
                                                    code: 90,
                                                    phone: ''
                                                },
                                                phone2: {
                                                    code: 90,
                                                    phone: ''
                                                }
                                            }}
                                            onValuesChange={() => {
                                                const formData = patientFormRef.current.getFieldsValue()
                                                formData.name = formData.name?.toLocaleUpperCase()
                                                formData.lastname = formData.lastname?.toLocaleUpperCase()
                                                formData.note = formData.note?.toLocaleUpperCase()
                                                formData.address = formData.address?.toLocaleUpperCase()
                                                formData.customId = formData.customId?.toLocaleUpperCase()
                                                formData.otherPatientId = formData.otherPatientId?.toLocaleUpperCase()
                                                formData.motherName = formData.motherName?.toLocaleUpperCase()
                                                formData.fatherName = formData.fatherName?.toLocaleUpperCase()

                                                setPatientData({
                                                    ...patientData,
                                                    ...formData
                                                })

                                                patientFormRef.current.setFieldsValue({
                                                    ...formData,
                                                    phone1: {
                                                        code: formData.phone1.code || 90,
                                                        phone: Helper.Phone.phoneFormat(formData.phone1.phone)
                                                    },
                                                    phone2: {
                                                        code: formData.phone2.code || 90,
                                                        phone: Helper.Phone.phoneFormat(formData.phone2.phone)
                                                    }
                                                })
                                            }}
                                            ref={patientFormRef}
                                        >
                                            <Row>
                                                <Col xs={24}>
                                                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                                        <Form.Item>
                                                            <AddonBefore width={100} external={true}>
                                                                {t('Identity')}
                                                            </AddonBefore>
                                                        </Form.Item>
                                                        <Form.Item
                                                            name={'customId'}
                                                            style={{ width: '100%' }}
                                                            rules={[{ ...(validate.customId || {}) }]}
                                                        >
                                                            <Input
                                                                onKeyUp={(e) => {
                                                                    if (e.key === 'Enter') {
                                                                        onEnterRef.current = true
                                                                        selectPatient(patientFormRef.current?.getFieldsValue()?.customId, true, true)
                                                                    }
                                                                }}
                                                                onBlur={() => {
                                                                    if (onEnterRef.current) {
                                                                        onEnterRef.current = false
                                                                        return
                                                                    }

                                                                    const customId = patientFormRef.current?.getFieldsValue()?.customId
                                                                    if (patientData.validate && patientData.originalCustomId === customId) {
                                                                        return
                                                                    }

                                                                    selectPatient(customId, false, true)
                                                                }}
                                                            />
                                                        </Form.Item>
                                                        <Form.Item>
                                                            <AddonBefore width={32} external={true} style={{ paddingRight: 0 }}>
                                                                {!validateTCKN(patientData?.customId?.toString()) ? (
                                                                    <Tooltip
                                                                        title={t('The entered identification information does not match the 11-digit format of a Turkish national ID number.')}>
                                                                        <WarningOutlined style={{ color: 'orange' }} />
                                                                    </Tooltip>
                                                                ) : (
                                                                    <CheckOutlined style={{ color: 'green' }} />
                                                                )}
                                                                <Button
                                                                    style={{ marginLeft: 4 }}
                                                                    size={'small'}
                                                                    type={'dashed'}
                                                                    disabled={!patientData?.validate}
                                                                    onClick={openPatientResults}
                                                                >
                                                                    {t('Patient Results')}
                                                                </Button>
                                                            </AddonBefore>
                                                        </Form.Item>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row style={{ width: '100%' }}>
                                                <Col xl={12} xs={24}>
                                                    <Form.Item
                                                        name={'name'}
                                                        rules={[
                                                            { required: true, message: t('Please enter name') }
                                                        ]}
                                                    >

                                                        <Input
                                                            addonBefore={<AddonBefore width={70}>{t('Name')}</AddonBefore>}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col xl={12} xs={24}>
                                                    <Form.Item
                                                        name={'lastname'}
                                                        rules={[
                                                            { required: true, message: t('Please enter lastname') }
                                                        ]}
                                                    >
                                                        <Input
                                                            addonBefore={<AddonBefore width={70}>{t('Lastname')}</AddonBefore>}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={24} xl={12}>
                                                    <Form.Item
                                                        name="phone1"
                                                        rules={[
                                                            { ...(validate.phone1 || {}) }
                                                        ]}
                                                    >
                                                        <CountryPhoneInput
                                                            addonBefore={<AddonBefore
                                                                width={70}>{t('Phone') + " 1"}</AddonBefore>}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} xl={12}>
                                                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                                        <Form.Item>
                                                            <AddonBefore width={70} external={true}>
                                                                {t('Birthdate')}
                                                            </AddonBefore>
                                                        </Form.Item>
                                                        <Form.Item
                                                            style={{ flex: 1 }}
                                                            name={'birthDay'}
                                                            rules={[{ ...(validate.birthdate || {}) }]}
                                                        >
                                                            <InputNumber
                                                                min={1}
                                                                max={31}
                                                                placeholder={t('Day')}
                                                                style={{ width: '100%' }}
                                                            />
                                                        </Form.Item>
                                                        <Form.Item
                                                            style={{ flex: 1 }}
                                                            name={'birthMonth'}
                                                            rules={[{ ...(validate.birthdate || {}) }]}
                                                        >
                                                            <InputNumber
                                                                style={{ width: '100%' }}
                                                                placeholder={t('Month')}
                                                                min={1}
                                                                max={12}
                                                            />
                                                        </Form.Item>
                                                        <Form.Item
                                                            style={{ flex: 1 }}
                                                            name={'birthYear'}
                                                            rules={[{ ...(validate.birthdate || {}) }]}
                                                        >

                                                            <InputNumber
                                                                style={{ width: '100%' }}
                                                                placeholder={t('Year')}
                                                                min={1900}
                                                                max={parseInt(new Date().getFullYear())}
                                                            />
                                                        </Form.Item>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>

                                                <Col xs={24} xl={12}>
                                                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                                        <Form.Item>
                                                            <AddonBefore width={100} external={true}>
                                                                {t('Gender')}
                                                            </AddonBefore>
                                                        </Form.Item>
                                                        <Form.Item
                                                            style={{ width: '100%' }}
                                                            name={'gender'}
                                                            rules={[{ ...(validate.gender || {}) }]}
                                                        >
                                                            <Select
                                                                style={{ width: '100%' }}
                                                                value={1}
                                                                placeholder={t('Cinsiyet')}
                                                                allowClear={true}
                                                            >
                                                                <Select.Option value={'M'}>{t('M')}</Select.Option>
                                                                <Select.Option value={'F'}>{t('F')}</Select.Option>
                                                                <Select.Option value={'O'}>{t('Other')}</Select.Option>
                                                            </Select>
                                                        </Form.Item>
                                                    </div>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col xs={24} xl={12}>
                                                    <Form.Item
                                                        name={'note'}
                                                    >
                                                        <Input.TextArea
                                                            placeholder={t('Patient Note')}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} xl={12}>
                                                    <Form.Item
                                                        name={'address'}
                                                    >
                                                        <Input.TextArea
                                                            placeholder={t('Address')}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col xs={24} xl={6}>
                                                    <Form.Item
                                                        name={'height'}
                                                    >
                                                        <InputNumber
                                                            style={{ width: '100%' }}
                                                            addonBefore={(<AddonBefore width={70}>{t('Height') + ' (cm)'}</AddonBefore>)}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} xl={6}>
                                                    <Form.Item
                                                        name={'weight'}
                                                    >
                                                        <InputNumber
                                                            style={{ width: '100%' }}
                                                            addonBefore={(<AddonBefore width={70}>{t('Weight') + ' (kg)'}</AddonBefore>)}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>

                                            <Form.Item
                                                name="phone2"
                                                rules={[]}
                                            >
                                                <CountryPhoneInput
                                                    addonBefore={<AddonBefore width={70}>{t('Phone') + " 2"}</AddonBefore>}
                                                />
                                            </Form.Item>

                                            <Row>
                                                <Col xl={12} xs={24}>
                                                    <Form.Item
                                                        name={'email'}
                                                        rules={[
                                                            {
                                                                validator: (_, value) => {
                                                                    if (!value) {
                                                                        return Promise.resolve();
                                                                    }
                                                                    if (!Helper.Text.validateEmail(value)) {
                                                                        return Promise.reject(t('Invalid email address'));
                                                                    }
                                                                    return Promise.resolve();
                                                                },
                                                            },
                                                        ]}
                                                    >
                                                        <Input
                                                            addonBefore={<AddonBefore width={70}>{t('Email')}</AddonBefore>}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col xl={12} xs={24}>
                                                    <Form.Item
                                                        name={'otherPatientId'}
                                                    >
                                                        <Input
                                                            addonBefore={<AddonBefore width={70}>{t('Other Id')}</AddonBefore>}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl={12} xs={24}>
                                                    <Form.Item name={'motherName'}>
                                                        <Input
                                                            addonBefore={<AddonBefore width={70}>{t('Mother Name')}</AddonBefore>}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col xl={12} xs={24}>
                                                    <Form.Item name={'fatherName'}>
                                                        <Input
                                                            addonBefore={<AddonBefore width={70}>{t('Father Name')}</AddonBefore>}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </ConfigProvider>
                                </Card>
                                {
                                    !isMobile && patientData?.id && (
                                        <div style={{ marginTop: 16 }}>
                                            <DataGridProvider>
                                                <AppointmentPatientDataGrid
                                                    filter={filter}
                                                    tableUpdate={tableUpdate}
                                                    onFilter={(data) => updateFilter(data)}
                                                    openCalendar={openCalendar}
                                                    onRows={(rows) => {
                                                        setSelectedAppointments(rows)
                                                    }}
                                                    rows={selectedAppointments}
                                                    onPayment={() => {
                                                        openPaymentModal(patientData)
                                                    }}
                                                />
                                            </DataGridProvider>
                                        </div>
                                    )
                                }
                            </TabPane>
                            <TabPane
                                tab={!patientData?.validate ? (
                                    <Tooltip title="Lütfen önce validasyonu tamamlayın!">
                                        <span>{t("Billing Address")}</span>
                                    </Tooltip>
                                ) : (
                                    t("Billing Address")
                                )} key="2"
                                disabled={!patientData?.validate}>
                                <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
                                    <PatientBillingAddress
                                        patientId={filter.patientId}
                                        patientName={patientData.name}
                                        patientLastname={patientData.lastname}
                                        patientCustomId={patientData.customId}
                                    />
                                </div>
                            </TabPane>
                            <TabPane tab={t("Patient Files")} key="3">
                                <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
                                    <PatientFiles
                                        files={patientData?.files || []}
                                        appointmentId={selectedAppointments[selectedAppointments.length - 1]?.appointmentId}
                                        onStateChanged={() => {
                                            setTableUpdate(v4())
                                        }}
                                    />
                                </div>
                            </TabPane>
                            <TabPane tab={t("Reminders")} key="4">
                                <AppointmentReminder
                                    patientId={filter.patientId}
                                />
                            </TabPane>
                        </Tabs>
                    </Col>
                    <Col xs={24} xl={12}>
                        {
                            (selectedAppointments?.length > 0 || newAppointment) && (
                                <AppointmentDetailEdit
                                    onPayment={() => {
                                        openPaymentModal(patientData)
                                    }}
                                    onAppointmentChange={(app) => selectedAppointmentRef.current = app}
                                    appointmentId={newAppointment || selectedAppointments[selectedAppointments.length - 1]?.appointmentId}
                                    onSave={async (app) => {
                                        const kvkkApproved = await checkKvkkConsent(filter.patientId);

                                        if (!kvkkApproved) {
                                            NotificationService.error(t('KVKK approval is required to save the appointment.'), t('Please approve KVKK consent.'));
                                            return;
                                        }

                                        const _patientId = await savePatient(false)
                                        selectedAppointmentRef.current = app
                                        await saveAppointment(_patientId, app)
                                    }}
                                    onDelete={async (appointment) => {
                                        const res = await ApiService.Appointment.DeleteAppointment(appointment.id);
                                        if (res.success) {
                                            setSelectedAppointments([])
                                            setNewAppointment(null)
                                            selectedAppointmentRef.current = null
                                            setTableUpdate(v4())
                                        }
                                    }}
                                    onCancel={() => {
                                        setSelectedAppointments([])
                                        setNewAppointment(null)
                                        selectedAppointmentRef.current = null
                                        setTableUpdate(v4())
                                    }}
                                    onStateChanged={() => {
                                        setTableUpdate(v4())
                                    }}
                                    onCheckedChange={async (e) => {
                                        setChecked(e)
                                    }}
                                />
                            )
                        }
                    </Col>
                    {
                        isMobile && (
                            <Col xs={24}>
                                <DataGridProvider>
                                    <AppointmentPatientDataGrid
                                        filter={filter}
                                        tableUpdate={tableUpdate}
                                        onFilter={(data) => updateFilter(data)}
                                        openCalendar={openCalendar}
                                        onRows={(rows) => {
                                            setSelectedAppointments(rows)
                                        }}
                                        rows={selectedAppointments}
                                        onPayment={() => {
                                            openPaymentModal(patientData)
                                        }}
                                    />
                                </DataGridProvider>
                            </Col>
                        )
                    }
                </Row>
            </Card>
        </SimpleLayout>
    )
}